class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.addEventListener('click', (event) => {
      let target = event.target.closest('.protect-plus-toggle');
      if (target) {
        handleToggle({ target: target }); 
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Store the current toggle state before updating the DOM
    let wasToggleEnabled = false;
    const protectPlusToggle = document.querySelector('.protect-plus-toggle');
    if (protectPlusToggle) {
      wasToggleEnabled = protectPlusToggle.classList.contains('enabled');
    } else {
      // If toggle doesn't exist yet, check localStorage
      const enabled = localStorage.getItem('protect_plus_enabled');
      wasToggleEnabled = enabled !== null ? JSON.parse(enabled) : true;
    }
    
    // Update the DOM
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    
    // Safely update sections
    this.getSectionsToRender().forEach((section) => {
      // Check if the section exists in parsedState
      if (parsedState.sections && parsedState.sections[section.id]) {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
          
        if (sectionElement) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }
    });

    // PROTECT PLUS LOGIC TO TRIGGER CLICK WHEN CART RENDERED
    // Only check if ProtectPlus should be added after cart is rendered
    setTimeout(() => {
      // Use the checkAndAddProtectPlus function if available
      if (typeof window.checkAndAddProtectPlus === 'function') {
        console.log('Checking if ProtectPlus should be added from cart drawer');
        window.checkAndAddProtectPlus();
      } else if (typeof window.addProtectPlusToCart === 'function') {
        console.log('Using addProtectPlusToCart as fallback');
        window.addProtectPlusToCart();
      }
    }, 500);
    

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.addEventListener('cart:update', this.onCartUpdate.bind(this));
  }
  
  onCartUpdate(event) {
    // Store the toggle state before cart update
    const protectPlusToggle = document.querySelector('.protect-plus-toggle');
    if (protectPlusToggle) {
      this.wasToggleEnabled = protectPlusToggle.classList.contains('enabled');
      console.log('CartDrawerItems: Stored toggle state before update:', this.wasToggleEnabled ? 'enabled' : 'disabled');
    }
  }
  
  renderContents(parsedState) {
    try {
      // Call the parent renderContents method
      super.renderContents(parsedState);
      
      // Restore the toggle state after rendering
      if (typeof this.wasToggleEnabled !== 'undefined' && window.variantStrings && window.variantStrings.protectPlus) {
        console.log('CartDrawerItems: Restoring toggle state after update:', this.wasToggleEnabled ? 'enabled' : 'disabled');
        setTimeout(() => {
          if (typeof simulateClickOnProtectPlusToggle === 'function') {
            simulateClickOnProtectPlusToggle(this.wasToggleEnabled);
          }
        }, 100); // Increased timeout to ensure DOM is fully updated
      }
    } catch (error) {
      console.error('Error in CartDrawerItems.renderContents:', error);
    }
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
